import { useState } from "react";
import { useMediaQuery } from "@mui/material";
import BrowseDialog from "./BrowseDialog";
import GuidelinesDialog from "./GuidelinesDialog";
import { Trans, useTranslation } from "react-i18next";
// import { trackEvent } from "../analytics/gtagHelper";

export default function PrivacyBanner() {
  const [isOpen, setIsOpen] = useState(true);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isGuidelinesOpen, setIsGuidelinesOpen] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const { t } = useTranslation();

  if (isOpen) {
    return (
      <div
        className=" bg-[#FFF8E8] p-2 flex justify-between items-center z-50 rounded-lg text-[9px] md:text-xs font-medium"
        style={{ boxShadow: "0px 0px 6px #00000029" }}
      >
        <BrowseDialog
          isOpen={isPrivacyOpen}
          setIsOpen={setIsPrivacyOpen}
          url="https://www.cashew.ai/privacy-policy"
        />
        <GuidelinesDialog
          isOpen={isGuidelinesOpen}
          setIsOpen={setIsGuidelinesOpen}
        />
        <div className="flex-1 text-gray-800">
          <Trans
            i18nKey="privacyBanner.message"
            components={{
              privacyLink: (
                <button
                  className="text-blue-600 underline font-medium"
                  onClick={() => {
                    setIsPrivacyOpen(true);
                    // trackEvent("privacyBannerOpen", { category: "Button" });
                  }}
                />
              ),
              guidelinesLink: (
                <button
                  className="text-blue-600 underline font-medium"
                  onClick={() => {
                    setIsGuidelinesOpen(true);
                    // trackEvent("agentGuidelinesOpen", { category: "Button" });
                  }}
                />
              ),
            }}
          />
        </div>
        <button
          onClick={() => {
            setIsOpen(false);
            // trackEvent("privacyBannerClose", { category: "Button" });
          }}
          className=" text-gray-500 hover:text-gray-700"
          aria-label={t("privacyBanner.closeAria")}
        >
          <img
            src="/icons/close.svg"
            alt={t("common.close")}
            className="w-4 h-4"
          />
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={() => setIsOpen(true)}
      className={`${
        isDesktop
          ? "right-0 self-end"
          : "fixed left-1/2 transform -translate-x-1/2"
      } py-1 px-2 bg-[#FFF8E8] rounded-full shadow-lg z-50 border border-gray-200 hover:bg-[#FFF0D0] transition-colors flex`}
      aria-label={t("privacyBanner.openAria")}
    >
      <img
        src="/icons/privacy_icon.svg"
        className="w-5"
        alt={t("common.privacyAlt")}
      />
    </button>
  );
}
